module.exports = __webpack_public_path__ + "static/media/veneto-village-07.17b159fb.jpg";